<template>
  <div id="app">
    <router-view v-if="isVisivle" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapState({
      isVisivle: state => state.user.isVisivle
    })
  },
  async created() {
    const result = await this.$store.dispatch('user/queryByDomain')
    this.$store.commit('user/QUERY_DOMAIN_FINISH', true)
    document.title = result.privateName
  }
}
</script>
